<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="search" show-action placeholder="请输入搜索关键词" @input="onSearch">
				<template #action>
					<div @click="showSelect">筛选</div>
				</template>
			</van-search>
			<div style="padding: 0 10px; background: #fff;">
				<van-tag closeable v-if="tag.date" size="medium" type="primary" @close="tagClose('date')">{{
				tagData.date.display }}</van-tag>
			</div>
		</van-sticky>

		<van-list v-model="list.loading" :finished="list.finished" finished-text="没有更多了" @load="onLoad"
			style="padding-bottom: 50px;">
			<van-swipe-cell
				v-for="(item, index) in list.list"
				:key="index"
			>
			<van-cell class="item-list" @click="surveyDetails(item.survey_id)">
				<div>
					<van-icon name="todo-list-o" />
					勘察编号: {{ item.survey_code }}
				</div>
				<div>
					<van-icon name="wap-home-o" />
					项目名称: {{ item.survey_name }}
				</div>
				<div>
					<van-icon name="records" />
					屏幕名称: {{ item.led_name }}
				</div>
				<div>
					<van-icon name="friends-o" />
					客户单位: {{ item.client_name }}
				</div>
				<div class="text-time">创建时间：{{ item.date }}</div>
				<van-tag class="item-tag" plain :type="tagPrimary[item.state].value">{{
					tagPrimary[item.state].text }}</van-tag>
			</van-cell>
				<template #right>
					<div class="swipe-button" >
						<van-button
							class="swipe-button"
							@click="application(item.survey_id,2)"
							square
							type="info"
							text="复制"
						/>
						<!-- <van-button
							class="swipe-button"
							@click="termination(item.survey_id)"
							square
							type="info"
							text="修改"
						/> -->
						<van-button 
							class="swipe-button"
							v-if="item.state == 0"
							@click="application(item.survey_id,1)"
							square
							type="warning"
							text="作废"
						/>
					</div>
				</template>
			</van-swipe-cell>
		</van-list>
		<van-tabbar v-model="activeName">
			<van-tabbar-item name="sign" icon="location-o" to="/sign">签到</van-tabbar-item>
			<van-tabbar-item name="list" icon="label-o" to="/sign/list">签到记录</van-tabbar-item>
			<van-tabbar-item name="survey" icon="browsing-history-o" to="/survey">勘察</van-tabbar-item>
			<van-tabbar-item name="surveyList" icon="certificate" to="/survey/list">勘察记录</van-tabbar-item>
		</van-tabbar>

		<van-action-sheet v-model="popup.select" :actions="actions" cancel-text="取消" @select="onSelect"
			@cancel="onCancel" />
		<van-calendar v-model="popup.date" type="range" @confirm="checkDate" />
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { signList } from "@/api/sign";
import { Toast,Dialog } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";
// import { ImagePreview } from "vant";
import { getNowFormatDate } from "@/utils/tool";

export default {
	name: "surveyList",
	components: {
		navbar,
	},
	data() {
		return {
			title: "勘察记录",
			activeName: "surveyList",
			search: "",
			list: {
				list: [],
				loading: false,
				finished: false,
				page: 1,
				limit: 15,
			},
			popup: {
				select: false,
				date: false,
			},
			actions: [
				{ name: "日期筛选", value: 0 },
			],
			tag: {
				date: false,
				// company: false,
			},
			tagData: {
				date: {
					start: "",
					end: "",
					display: "", // 显示的日期字符串
				},
			},
			tagPrimary: [
				{ text: "勘察中", value: "primary" },
				{ text: "已派单", value: "success" },
				{ text: "已完工", value: "success" },
				{ text: "已删除", value: "warning" },
				{ text: "已作废", value: "danger" },
			],
			imageList: [],
		};
	},
	methods: {
		onLoad() {
			let axiosData = new Object();
			axiosData.requestType = "survey_list_data";
			axiosData.page = this.list.page;
			axiosData.limit = this.list.limit;
			axiosData.search = this.search;
			axiosData.search_start_date = this.tagData.date.start;
			axiosData.search_end_date = this.tagData.date.end;

			signList(axiosData)
				.then((response) => {
					if (response.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.list.page != 1) {
						this.list.list = this.list.list.concat(
							response.obj.rows
						);
					} else {
						this.list.list = response.obj.rows;
					}

					this.list.page += 1;
					this.list.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast.fail("网络连接错误,请求超时,请稍后重试!");
				});
		},
		onSearch() {
			this.list.page = 0;
			this.list.list = [];
			this.onLoad();
		},
		showSelect() {
			this.popup.select = true;
		},
		onSelect(item) {
			if (item.value === 0) {
				this.popup.date = true;
			}
			this.popup.select = false;
		},
		onCancel() {
			this.popup.select = false;
		},
		checkDate(date) {
			this.popup.date = false;
			const startDate = getNowFormatDate(date[0]);
			const endDate = getNowFormatDate(date[1]);
			this.setTag(startDate, endDate, "date");
		},
		setTag(start,end,type) {
			if (type == "date") {
				this.tagData.date.start = start;
				this.tagData.date.end = end;
				this.tagData.date.display = `${start} 至 ${end}`;
			}
			this.list.page = 0;
			this.list.list = [];
			this.onLoad();
			this.tag[type] = true;
		},
		tagClose(type) {
			if (type == "date") {
				this.tagData.date.start = "";
				this.tagData.date.end = "";
				this.tagData.date.display = ""; 
			}
			this.list.page = 0;
			this.onLoad();
			this.tag[type] = false;
		},
		surveyDetails(id) {
			// console.log(id);
			this.$router.push({
				path: "/survey/details",
				query: { id: id, p: true },
			});
			//调转查看页面
		},
		application(survey_id,type){
			let message = "";
			if(type == 1){
				message = "确定作废该订单吗？";
			}else{
				message = "确定复制该订单吗？";
			}
			Dialog.confirm({
				title: '提示',
				message: message,
			})
				.then(() => {
					let formData = new FormData();
					formData.append("requestType", "survey_add");
					formData.append("survey_id", survey_id);
					if (type == 1) {
						formData.append("state", 4);
					}
					formData.append("type", type);
					formData.append("token", getToken());
					const config = {
						headers: {
							"Content-Type": "multipart/form-data"
						}
					};
					axios
						.post(this.GLOBAL.httpURL, formData, config)
						.then((res) => {
							console.log(res);
							if (res.data.code === 200) {
								Toast.success("提交成功!");
								this.list.page = 0;
								this.list.list = [];
								this.onLoad();
							}else{
								Toast.fail("提交失败,请稍后重试!");
							} 
						})
						.catch(() => {
							Toast.fail("提交失败,请稍后重试!");
						});
				})
		}
	},
};
</script>

<style>
.van-tag+.van-tag {
	margin-left: 8px;
}

.item-tag {
	position: absolute;
	right: 15px;
	bottom: 10px;
}

.text-time {
	margin-top: 8px;
	font-size: 12px;
	color: #999;
}
.swipe-button {
	height: 100%;
}
</style>
